import React, { useEffect, useState } from "react";
import "../../css/wb_transaction_detail.css";
import axios from "axios";
import CollapsibleTable from "../../components/WalletTable";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import Export from "../../Assets/images/export.png";
import excelIcon from "../../Assets/images/excel.png";
import SearchIcon from "@mui/icons-material/Search";
import baseURL from '../../config.js'
import { ClipLoader } from "react-spinners";
import { SettingsApplicationsOutlined } from "@mui/icons-material";



const WbTransactionDetail = () => {

  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchValue] = useState('');
  const [debouncedSearchInput, setDebouncedSearchInput] = useState(searchInput);
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: true,
    message: "",
  });

  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [collapseTable, setCollapseTable] = useState(false);


  const handleCloseSnackBar = () => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const fetchRowDetails = async () => {
    console.log('Fetch row details ')
  }

  const fetchTransactions = async (page = 1, limit = 10) => {
    setLoading(true);
    try {
      let endpoint = `api/transaction/get-balance-details?page=${page}&limit=${limit}`;
      if (debouncedSearchInput) {
        endpoint = `${endpoint}&search=${debouncedSearchInput}`;
      }

      const res = await apiCall({
        endpoint: endpoint,
        method: "GET",
      });
      if (res?.success) {
        setRows(res?.data || []);
        setTotalRows(res?.total || 0);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // Debouncing effect
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setDebouncedSearchInput(searchInput);
    }, 500); // Set delay to 500ms

    return () => clearTimeout(delayDebounceFn); // Clear the timeout if searchInput changes
  }, [searchInput]);

  useEffect(() => {
    fetchTransactions();
  }, [debouncedSearchInput]);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleFormSubmit = async (type, amount, userId, remarks, balanceId, adminId) => {
    setLoading(true);
    try {
      const payload = { 
        type, 
        balance: parseFloat(parseFloat(amount).toFixed(3)), 
        userId, 
        remarks,
        adminId 
      }
      const res = await apiCall({
        endpoint: `api/transaction/save-balance?balanceId=${balanceId ?? ""}`,
        method: "POST",
        payload: payload,
      });
      if (res?.success) {
        setCollapseTable(false)
        await fetchTransactions()
        setSnackBar({
          open: true,
          severity: res?.success,
          message: res?.message || "An error occurred",
        });

      }
    } catch (error) {
      console.log(error )
      setSnackBar({
        open: true,
        severity: false,
        message: error?.response?.data?.error || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="Manage_voice_contian">
        <h4 className="Head_title AdminSearchContain titleHead" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          Active Dealers{" "}

          <div className="Session_report_SearchContain user_details_search">
            <input
              placeholder="Search"
              value={searchInput}
              onChange={handleSearchChange}
              type="text"
              className=""
            />
            {/* <button type="button"><SearchIcon /></button> */}
          </div>
          {/* <button className="add_btn7">
            <img src={Export} alt="img" /> Export
          </button> */}
          {/* <button type="button" className="ExcelIconContain add_btn7" onClick={handleExportToExcel}>
                <img src={excelIcon} alt="excelIcon" className="ExcelIcon"/> 
        </button> */}
        </h4>
        <div className="Manage_voice_Card">
          <div className="Wallet_table">
            <CollapsibleTable
              rows={rows}
              totalRows={totalRows}
              onSubmit={handleFormSubmit}
              fetchTransactions={fetchTransactions}
              fetchRowDetails={fetchRowDetails}
              collapseTable={collapseTable}
              setCollapseTable={setCollapseTable}
            />
          </div>
        </div>
      </div>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </>
  );
};

export default WbTransactionDetail;
